module.exports = __webpack_public_path__ + "static/media/vinyl-snooze.9bfb8a97.webp";